angular.module('eStories.purchase.confirm', [
    'global.validation.model',
    'eStories.billing.model'
]).controller('ConfirmPurchaseCtrl',
    ['ModalsModel', 'ValidationModel', '$uibModalInstance', '$controller', '$scope', 'AccountModel', 'BillingModel',
        '$location', '$filter', 'LL', 'GoogleModel', 'GA', 'PromoModel', 'CtaModel', 'AffiliatesProgramModel',
        function (ModalsModel, ValidationModel, $uibModalInstance, $controller, $scope, AccountModel, BillingModel,
                  $location, $filter, LL, GoogleModel, GA, PromoModel, CtaModel, AffiliatesProgramModel) {
            if (!PromoModel.hasCreditPromo()) {
                AccountModel.setChosenPlan(null);
            }

            var confirmPurchaseCtrl = this;

            confirmPurchaseCtrl.purchaseInProgress = false;

            var purchaseCtrl = $controller('PurchaseCtrl', {$scope: $scope});
            angular.extend(this, purchaseCtrl);

            confirmPurchaseCtrl.todaysDate = new Date();

//            uncomment this when booster sale goes live vvvvv
            AccountModel.extraCreditSale();

            confirmPurchaseCtrl.closePurchaseConfirmation = function () {
                $uibModalInstance.close();
            };

            confirmPurchaseCtrl.showUpdatePaymentDetails = function () {
                $uibModalInstance.close();
                BillingModel.isPlanPurchase = false;
                AccountModel.showUpdatePaymentDetailsModal();
            };

            confirmPurchaseCtrl.showConfirmSignUpModal = function (isJoinNow) {
                $uibModalInstance.close();
                if (isJoinNow) {
                    AccountModel.setPendingPlanPurchaseType("PLAN");
                    AccountModel.setPendingPostChoosePlanAction("SHOW_PAYMENT_DETAILS_FORM");
                    if (AccountModel.isUserLoggedIn) {
                        AccountModel.showChoosePlanModal();
                    } else {
                        AccountModel.showSignUp();
                    }
                } else {
                    AccountModel.setPendingPlanPurchaseType(null);
                    AccountModel.showSignUp();
                }
            };

            confirmPurchaseCtrl.purchasePendingBooster = async function () {
                var boosterPlan = confirmPurchaseCtrl.getBoosterPlan();

                try {
                    const response = await BillingModel.purchaseBooster(boosterPlan.planPricingId, PromoModel.promoCodeHash);
                    confirmPurchaseCtrl.purchaseInProgress = false;
                    safeApply($scope);
                    LL.tagXtraCreditPurchaseEvent(boosterPlan.price, response);
                    GoogleModel.trackConversion("JAySCLLZqmcQ_puwuQM", parseFloat(boosterPlan.price), boosterPlan.currency);
                    if (response.responseText === "SUCCESS") {
                        $uibModalInstance.close();
                        GA.trackEvent('Purchase', 'Extra Credit Purchase', boosterPlan.name, parseFloat(boosterPlan.price).toFixed(0));
                        AccountModel.refreshSubscriptionDetails();
                        if (PromoModel.hasCreditPromo()) {
                            PromoModel.clearPromoPackage();
                        }
                        AccountModel.showPostBoosterPurchaseModal();
                        return;
                    }

                    switch (response.responseText) {
                        case "BILLING_ERROR":
                        case "BILLING_PROVIDER_ERROR":
                            confirmPurchaseCtrl.displayPurchaseBoosterError(response.billingError);
                            break;
                        default:
                            confirmPurchaseCtrl.displayPurchaseBoosterError(response.responseText);
                            break;
                    }
                } catch (error) {
                    confirmPurchaseCtrl.displayPurchaseBoosterError(error);
                    confirmPurchaseCtrl.purchaseInProgress = false;
                    safeDigest($scope);
                }
            };

            confirmPurchaseCtrl.updatePlanImmediately = async function () {
                var conversionPlan = confirmPurchaseCtrl.getConversionPlan();
                var subscriptionId = AccountModel.subscriptionDetails.subscription.id;

                var utmRequest = AffiliatesProgramModel.getUtmRequestObj();
                try {
                    const response = await BillingModel.updatePlanImmediately(subscriptionId, conversionPlan.planPricingId, null, utmRequest);
                    LL.tagSubscriptionPurchase(
                        conversionPlan,
                        AccountModel.getNextCreditRenewalDate(),
                        AccountModel.getNextBillingAttemptDate(),
                        AccountModel.getSubscriptionName(conversionPlan),
                        (AccountModel.savedPaymentDetails !== null
                            ? (AccountModel.savedPaymentDetails.paymentMethod === 'PAYPAL' ? 'PayPal' : 'Credit Card')
                            : null),
                        response,
                        null,
                        null,
                        null,
                        null,
                        AffiliatesProgramModel.getUtmRequestObj() ? AffiliatesProgramModel.getUtmRequestObj().utmSource : null
                    );
                    if (response.responseText === "SUCCESS") {
                        // Now we buy the audiobook with credit
                        confirmPurchaseCtrl.setPurchaseType("CREDIT");
                        confirmPurchaseCtrl.confirmPurchase();
                        return;
                    }
                    confirmPurchaseCtrl.purchaseInProgress = false;
                    switch (response.responseText) {
                        case "BILLING_ERROR":
                        case "BILLING_PROVIDER_ERROR":
                            confirmPurchaseCtrl.displayUpdatePlanImmediatelyError(response.billingError);
                            break;
                        default:
                            confirmPurchaseCtrl.purchaseError = BillingModel.getPurchaseError(response.responseText);
                            break;
                    }
                } catch (error) {
                    confirmPurchaseCtrl.displayUpdatePlanImmediatelyError(error);
                    confirmPurchaseCtrl.purchaseInProgress = false;
                    safeDigest($scope);
                }
            };

            confirmPurchaseCtrl.displayErrorWithCode = function (message, code) {
                confirmPurchaseCtrl.purchaseError = message;
                if (code) {
                    code = code.toLowerCase().replace(/_/g, " ").trim().replace(/(^[a-z])/g, function (a) {
                        return a.toUpperCase()
                    });
                    confirmPurchaseCtrl.purchaseError += " (" + code + ")";
                }
                safeApply($scope);
            };

            confirmPurchaseCtrl.displayPurchaseBoosterError = function (code) {
                confirmPurchaseCtrl.displayErrorWithCode("Unable to purchase extra credit", code);
            };

            confirmPurchaseCtrl.displayUpdatePlanImmediatelyError = function (code) {
                confirmPurchaseCtrl.displayErrorWithCode("Unable to start plan now", code);
            };

            confirmPurchaseCtrl.confirmPurchase = function () {
                var purchaseType = purchaseCtrl.getPurchaseType();
                confirmPurchaseCtrl.purchaseInProgress = true;

                if (purchaseType == "BOOSTER") {
                    confirmPurchaseCtrl.purchasePendingBooster();
                    return;
                }

                if (purchaseType == "START_PLAN_NOW") {
                    confirmPurchaseCtrl.updatePlanImmediately();
                    return;
                }

                if (!AccountModel.isUserLoggedIn) {
                    // Close dialog and send to sign up
                    confirmPurchaseCtrl.showConfirmSignUpModal();
                    return;
                }

                var audiobookPrice = parseInt(AccountModel.getMyAudiobookPrice(purchaseCtrl.getAudiobook(), false));

                if (purchaseType === "RETAIL" && purchaseCtrl.getSavedPaymentDetails() === null && audiobookPrice > 0) {
                    AccountModel.setPendingAudiobookPurchase(purchaseCtrl.getAudiobook(), purchaseType);
                    confirmPurchaseCtrl.showUpdatePaymentDetails();
                    BillingModel.isPlanPurchase = false;
                    return;
                }

                purchaseCtrl.purchasePendingAudiobook(function () {
                    confirmPurchaseCtrl.purchaseInProgress = false;
                    $location.path("/library");
                    $uibModalInstance.close();
                    safeDigest($scope);
                    AccountModel.resetPlanPurchaseProperties();
                }, function (error) {
                    confirmPurchaseCtrl.purchaseInProgress = false;
                    confirmPurchaseCtrl.purchaseError = error;
                    safeApply($scope);
                })
            };

            confirmPurchaseCtrl.switchToCredits = function () {
                purchaseCtrl.getPendingAudiobookPurchase().purchaseType = "CREDIT";
            };

            confirmPurchaseCtrl.shouldShowCtaText = function () {
                return !confirmPurchaseCtrl.isStartPlanPurchase()
                    && !confirmPurchaseCtrl.isBoosterPurchase()
                    && confirmPurchaseCtrl.isOnTrial()
                    && confirmPurchaseCtrl.isAlcPurchase()
                    && !confirmPurchaseCtrl.hasAvailableCredit();
            };

            confirmPurchaseCtrl.getTitleText = function () {
                if (confirmPurchaseCtrl.isBoosterPurchase()) {
                    return "confirm";
                } else if (confirmPurchaseCtrl.isStartPlanPurchase()) {
                    return "Start now!"
                } else {
                    return "Confirm";
                }
            };

            confirmPurchaseCtrl.getBoosterPlan = function () {
                if (confirmPurchaseCtrl.allPlansMap == null) {
                    return null;
                }
                return confirmPurchaseCtrl.allPlansMap["BOOSTER"][0];
            };

            confirmPurchaseCtrl.isBoosterPurchase = function () {
                if (purchaseCtrl.getPendingAudiobookPurchase() == null) {
                    return false;
                }

                return purchaseCtrl.getPendingAudiobookPurchase().purchaseType == "BOOSTER";
            };

            confirmPurchaseCtrl.isStartPlanPurchase = function () {
                if (purchaseCtrl.getPendingAudiobookPurchase() == null) {
                    return false;
                }

                return purchaseCtrl.getPendingAudiobookPurchase().purchaseType == "START_PLAN_NOW";
            };

            confirmPurchaseCtrl.isPendingAudiobookPurchaseFree = function (audiobook) {
                if (!audiobook) {
                    return
                }
                return CtaModel.isAudiobookFree(audiobook);
            };

            confirmPurchaseCtrl.isDailyDeal = function () {
                return purchaseCtrl.CatalogModel.dailyDeal.id === purchaseCtrl.getAudiobook().id;
            };

            confirmPurchaseCtrl.getDailyDealOfferCopy = function () {
                return 'Join now to enjoy our limited time book offers!';
            };

            confirmPurchaseCtrl.getSubText = function () {
                if (confirmPurchaseCtrl.isGiftCreditPurchase()) {
                    return "Buy with 1 Gift Credit?"
                }

                if (confirmPurchaseCtrl.isBoosterPurchase()) {
                    if (PromoModel.hasCreditPromo()) {
                        return PromoModel.promoPackage.checkoutCopy;
                    }
                    var boosterPlan = confirmPurchaseCtrl.getBoosterPlan();
                    var boosterPrice = $filter("currencyToSymbol")(boosterPlan.currency) + boosterPlan.price;
                    var boosterCredits = BillingModel.getPlanNumOfCredits(boosterPlan);
                    return "Buy " + boosterCredits + " credits for " + boosterPrice + "?";
                }

                if (confirmPurchaseCtrl.isStartPlanPurchase()) {
                    return "Start Membership & use first credit?"
                }

                if (!confirmPurchaseCtrl.isAlcPurchase() && confirmPurchaseCtrl.isOnTrial()) {
                    return "Buy with 1 Trial Credit?";
                }

                if (!confirmPurchaseCtrl.isAlcPurchase() && !confirmPurchaseCtrl.isOnTrial()) {
                    return "Buy with 1 Credit?";
                }

                if (confirmPurchaseCtrl.isAlcPurchase()) {
                    return "Buy for " + AccountModel.getPrice(confirmPurchaseCtrl.getAudiobook(), true);
                }

                if (PromoModel.hasCreditPromo() && confirmPurchaseCtrl.isBoosterPurchase()) {
                    return PromoModel.promoPackage.checkoutCopy;
                }
            };

            confirmPurchaseCtrl.getBoosterSubText = function () {
                if (!confirmPurchaseCtrl.isBoosterPurchase()) {
                    return "";
                }

                var boosterPlan = confirmPurchaseCtrl.getBoosterPlan();
                var boosterCredits = BillingModel.getPlanNumOfCredits(boosterPlan);
                var pricePerCredit = (boosterPlan.price / boosterCredits).toFixed(2);
                var boosterPrice = $filter("currencyToSymbol")(boosterPlan.currency) + pricePerCredit;

                return "Only " + boosterPrice + " per credit";
            };


            confirmPurchaseCtrl.getConversionPlan = function () {
                if (AccountModel.chosenPlan != null) {
                    return AccountModel.chosenPlan;
                }

                return AccountModel.subscriptionDetails.subscription.conversionPlan;
            };

            confirmPurchaseCtrl.getStartPlanSubText = function () {
                if (!confirmPurchaseCtrl.isStartPlanPurchase()) {
                    return ""
                }
                var conversionPlan = confirmPurchaseCtrl.getConversionPlan();
                var cycle = conversionPlan.billingCycleUnitType == "MONTHLY" ? "Monthly" : "Annually";
                return conversionPlan.name + " " + cycle + " Membership";
            }
        }
    ]
);